import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchConfig } from "@/components/dynamic-form";
import { SearchBarType } from "@/components/dynamic-form/constants";

export function getSearchConfig(): SearchConfig[] {
  const t = getTranslateNsT("center");
  return [
    {
      type: SearchBarType.Input,
      field: "projectName",
      label: t("user_com_childPro_head_label_name"),
    },
  ];
}
